import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  const processSession = useCallback(async () => {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      navigate('/dashboard');
      return;
    }
    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/auth/session`,
        { session_id: sessionId },
        { withCredentials: true }
      );
      const user = response.data;
      const destination = user.role === 'admin' ? '/admin' : '/dashboard';
      navigate(destination, { state: { user }, replace: true });
    } catch (error) {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processSession();
  }, [processSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#1A4331] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-stone-600 font-medium">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
